import { render, staticRenderFns } from "./ExportInCome.vue?vue&type=template&id=168dc0f8&scoped=true"
import script from "./ExportInCome.vue?vue&type=script&lang=js"
export * from "./ExportInCome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168dc0f8",
  null
  
)

export default component.exports